<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">
  <app-unidades-medida-listado
    *ngIf="seccion === 'LIS'"
    (dismiss)="cambioSeccion($event)"
    [unidadesMedidasCultivo]="unidadesMedidasCultivo"
  >
  </app-unidades-medida-listado>
  <app-unidad-medida-form
    *ngIf="seccion === 'FORM'"
    [unidadMedidaCultivo]="unidadMedidaCultivo"
    (dismiss)="cambioSeccion($event)"
    [unidadesMedidasCultivo]="unidadesMedidasCultivo"
  ></app-unidad-medida-form>
</div>
